import { convertTimestampToDaysAgo } from "../helpers/util";
import { ReactComponent as Heart } from "../assets/svg/heart.svg";
import { useDispatch, useSelector } from "react-redux";
import { addToFavorites, removeFromFavorites } from "../services/api";
import {
  pushUserFavoritesData,
  setHoveredListing,
  setUserFavoritesData,
} from "../store/reducers/listingReducer";
import { Link } from "react-router-dom";

export const ListItem = ({ listing }: { listing: any }) => {
  const dispatch = useDispatch();
  const userFavorites = useSelector(
    (state: any) => state.listingReducer.userFavorites
  );

  const logged = useSelector((state: any) => state.listingReducer.logged);

  function isFavorited(listingFav: any) {
    for (let i = 0; i < userFavorites.length; i++) {
      if (userFavorites[i].listing_unique_id === listingFav.listing_unique_id) {
        return true; // Found the target listing_unique_id in the array
      }
    }
    return false;
  }

  function removeFavoritesItemByListingListingUniqueId(listingFav: any) {
    // Use Array.prototype.filter to create a new array without the target item
    return userFavorites.filter(
      (item: any) => item.listing_unique_id !== listingFav.listing_unique_id
    );
  }

  async function toggleFavorite(listingFav: any) {
    if (!logged) {
      return;
    }
    let params: any = {};
    params["listing_unique_id"] = listingFav.listing_unique_id;
    if (isFavorited(listingFav)) {
      let result = await removeFromFavorites(params);
      if (!result?.data.success) {
        return;
      }
      let newFavorites =
        removeFavoritesItemByListingListingUniqueId(listingFav);
      dispatch(setUserFavoritesData(newFavorites));
    } else {
      let result = await addToFavorites(params);
      if (!result?.data.success) {
        return;
      }
      if (result) {
        dispatch(pushUserFavoritesData(result?.data.data));
      }
    }
  }

  const onMouseEnter = () => {
    dispatch(setHoveredListing(listing));
  };
  const onMouseLeave = () => {
    dispatch(setHoveredListing(null));
  };

  return logged ? (
    <Link to={`/${listing.listing_unique_id}`}>
      <ArticleContent
        listing={listing}
        logged={logged}
        toggleFavorite={toggleFavorite}
        isFavorited={isFavorited}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </Link>
  ) : (
    <ArticleContent
      listing={listing}
      logged={logged}
      toggleFavorite={toggleFavorite}
      isFavorited={isFavorited}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};

export const ListItemCommercial = ({ listing }: { listing: any }) => {
  const dispatch = useDispatch();
  const userFavorites = useSelector(
    (state: any) => state.listingReducer.userFavorites
  );

  const logged = useSelector((state: any) => state.listingReducer.logged);

  function isFavorited(listingFav: any) {
    for (let i = 0; i < userFavorites.length; i++) {
      if (userFavorites[i].listing_unique_id === listingFav.listing_unique_id) {
        return true; // Found the target listing_unique_id in the array
      }
    }
    return false;
  }

  function removeFavoritesItemByListingListingUniqueId(listingFav: any) {
    // Use Array.prototype.filter to create a new array without the target item
    return userFavorites.filter(
      (item: any) => item.listing_unique_id !== listingFav.listing_unique_id
    );
  }

  async function toggleFavorite(listingFav: any) {
    if (!logged) {
      return;
    }
    let params: any = {};
    params["listing_unique_id"] = listingFav.listing_unique_id;
    if (isFavorited(listingFav)) {
      let result = await removeFromFavorites(params);
      if (!result?.data.success) {
        return;
      }
      let newFavorites =
        removeFavoritesItemByListingListingUniqueId(listingFav);
      dispatch(setUserFavoritesData(newFavorites));
    } else {
      let result = await addToFavorites(params);
      if (!result?.data.success) {
        return;
      }
      if (result) {
        dispatch(pushUserFavoritesData(result?.data.data));
      }
    }
  }

  const onMouseEnter = () => {
    dispatch(setHoveredListing(listing));
  };
  const onMouseLeave = () => {
    dispatch(setHoveredListing(null));
  };

  return logged ? (
    <Link to={`/commercial/${listing.listing_unique_id}`}>
      <ArticleContent
        listing={listing}
        logged={logged}
        toggleFavorite={toggleFavorite}
        isFavorited={isFavorited}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        isCommercial={true}
      />
    </Link>
  ) : (
    <ArticleContent
      listing={listing}
      logged={logged}
      toggleFavorite={toggleFavorite}
      isFavorited={isFavorited}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};

const ArticleContent = ({
  listing,
  logged,
  toggleFavorite,
  isFavorited,
  onMouseEnter,
  onMouseLeave,
  isCommercial,
}: {
  listing: any;
  logged: boolean;
  toggleFavorite: any;
  isFavorited: any;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  isCommercial?: boolean;
}) => (
  <article
    onMouseLeave={onMouseLeave}
    onMouseEnter={onMouseEnter}
    className="border border-gray-200 bg-white"
  >
    <div className="relative">
      <img
        src={
          "https://maps.googleapis.com/maps/api/streetview?size=356x200&location=" +
          listing.latitude +
          "," +
          listing.longitude +
          "&key=AIzaSyCclBCu30QD5vsNQKwg8PKrn2EofxY6YP4&source=outdoor"
        }
        alt="listing"
        className="w-full"
      />
      <div className="absolute flex justify-between w-full p-2 top-0">
        <div>
          <span
            style={{ paddingTop: "2px", paddingBottom: "2px" }}
            className="px-2 border border-blue-200 bg-blue-50 text-blue-700 h-fit"
          >
            {convertTimestampToDaysAgo(listing.time_listed)}
          </span>
          {listing.source_type ? (
            <div className="mt-2">
              <span
                style={{ paddingTop: "2px", paddingBottom: "2px" }}
                className="px-2 border border-blue-200 bg-blue-50 text-blue-700 h-fit"
              >
                {listing.source_type}
              </span>
            </div>
          ) : null}
        </div>

        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleFavorite(listing);
          }}
          className={`p-3 ${
            isFavorited(listing) ? "bg-rose-600" : "bg-white bg-opacity-50"
          } border border-white border-opacity-60 text-white`}
        >
          <Heart />
        </button>
      </div>
    </div>

    <ItemBody listing={listing} logged={logged} isCommercial={isCommercial} />
  </article>
);
const ItemBody = ({
  listing,
  logged,
  isCommercial,
}: {
  listing: any;
  logged: boolean;
  isCommercial?: boolean;
}) => {
  return (
    <div className={`px-4 pb-4 pt-5 ${logged ? "" : "blur"}`}>
      <div className="flex justify-between">
        {/* <span className="text-xl font-bold text-gray-900"></span> */}
        <span></span>
        <span
          style={{ paddingTop: "2px", paddingBottom: "2px" }}
          className="px-2 border leading-5"
        >
          {listing.lead_status}
        </span>
      </div>

      {/* hard-coded */}
      {!isCommercial ? (
        <div className="mt-3 font-semibold flex gap-x-2">
          <span>{listing.bedrooms} Beds</span>
          <span className="border h-6"></span>
          <span>{listing.bathrooms} Baths</span>
          <span className="border h-6"></span>
          <span>
            {listing.sq_ft} {listing.lot_size_unit || "Sq ft"}
          </span>
        </div>
      ) : null}

      <div className="text-sm font-semibold text-primary mt-3 line-clamp-1 min-h-5">
        {listing.address}
        {listing.address ? ", " : ""}
        {listing.city}
        {listing.city ? ", " : ""}
        {listing.state}
        {listing.zip_code ? " " : ""}
        {listing.zip_code}
      </div>

      {!isCommercial ? (
        <div className="mt-3 text-gray-900 text-lg font-medium line-clamp-1 min-h-6">
          {listing.name}
        </div>
      ) : null}

      {/* <div className="mt-3 flex justify-between">
        <span
          style={{ paddingTop: "2px", paddingBottom: "2px" }}
          className="px-2 border leading-5"
        >
          {listing.lead_status}
        </span>
        <span
          style={{ paddingTop: "2px", paddingBottom: "2px" }}
          className="px-2 border border-blue-200 bg-blue-50 text-blue-700"
        >
          {convertTimestampToDaysAgo(listing.time_listed)}
        </span>
      </div> */}
    </div>
  );
};
